import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Body } from "../Certificates";
import Layout from "../../Components/Layout";
import Navbar from "../BannerItems/Components/Navigation";
import { NavStrip, HelmetTitle } from "../../Components/Utils";

import GERSModelMarkdown from "./GERSMarkdown.md";

class GersModel extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const name = "GERS Model";
    return (
      <div className="App">
      <HelmetTitle title="Model" />
      <Layout
        head={
          <React.Fragment>
            <Navbar />
            <NavStrip />
          </React.Fragment>
        }
        body={
          <React.Fragment>
            <Body name={name} markdownPath={GERSModelMarkdown}/>
          </React.Fragment>
          }
      />
      </div>  
    );
   }
}


export default withRouter(GersModel)


// WEBPACK FOOTER //
// ./src/Pages/GERSModel/index.js